import { render } from "./OrderTicket.vue?vue&type=template&id=382fa64b&scoped=true"
import script from "./OrderTicket.vue?vue&type=script&lang=js"
export * from "./OrderTicket.vue?vue&type=script&lang=js"

import "./OrderTicket.vue?vue&type=style&index=0&id=382fa64b&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-382fa64b"]])

export default __exports__